import { Separator } from "@/components/ui/separator";
import type { TopupHistoryItem } from "@/types/topup/history";
import { formatCurrency } from "@/utils/formatCurrency";
import { safeFormatDateTime } from "@/utils/formatDate";
import { ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";

type TopupHistoryCardProps = {
  topup: TopupHistoryItem;
};

export function TopupHistoryCard({
  topup,
}: TopupHistoryCardProps) {
  return (
    <Link
      to={`/topup-history/${topup.topUpNo}`}
      className="group rounded-2xl bg-card p-4 shadow-xl transition-shadow hover:shadow-2xl"
    >
      <div className="flex items-center justify-between gap-2 text-xs font-medium text-field">
        <p className="text-sm font-semibold text-heading">{topup.topUpNo}</p>

        {/** Uncomment after has E.Invoice */}
        {/* <div className="rounded-lg bg-primary-soft px-2 py-1 text-xs font-medium text-primary">
          E.Invoice
        </div> */}
      </div>

      <Separator orientation="horizontal" className="mt-2 text-border" />

      <div className="mt-4 flex items-center justify-between gap-2">
        <div className="flex items-center gap-2">
          <span className="text-sm font-semibold text-muted-foreground">
            {formatCurrency(topup.totalPrice)}
          </span>

          <Separator orientation="vertical" className="h-5 w-px text-border" />

          <span className="text-sm font-medium text-muted">
            {topup.pax} Pax.
          </span>
        </div>

        <ChevronRight
          size={24}
          className="text-primary transition-transform duration-200 group-hover:translate-x-1"
        />
      </div>

      <p className="mt-4 text-xs font-medium text-muted">
        {safeFormatDateTime(topup.purchaseDateTime)}
      </p>
    </Link>
  );
}